/** TRANSACTION_NAMES */
export enum TRANSACTION_NAMES {

    REVOKE_SIM_ONLY = 'revoke-SIM-only',
    REVOKE_CONTRACT_WITH_HW = 'revoke-contract-with-HW',
    REVOKE_CONTRACT_WITH_HW_SAME_SUB = 'change-contract-with-HW-same-sub',
    REVOKE_ACCESSORIES = 'revoke-accessories',
    CHANGE_CONTRACT_WITH_HW_DIFF_SUB = 'change-contract-with-HW-diff-sub',
    REVOKE_CONTRACT_WITH_HW_PURCHASE = 'revoke-contract-with-HW-purchase',
    SECOND_DELIVERY_SAME = '2nd-delivery-same',
    SECOND_DELIVERY_DIFFERENT = '2nd-delivery-different',
    DEFECT_RETURN = 'defect-return',
}
